import React, { Fragment } from 'react';

function ServedSectionHeaderRow(props) {
  const {
    collapsed,
    recipeCategoryId,
    servedTotalByRecCat,
    servedAlacarteTotalByRecCat,
    servedAdultTotalByRecCat,
    leftoverTotalByRecCat,
    discardTotalByRecCat,
    servedReimbTotalByRecCat,
    servedPreKTotalByRecCat,
  } = props;

  const servedTotal = servedTotalByRecCat[recipeCategoryId];
  const servedAlacarteTotal = servedAlacarteTotalByRecCat[recipeCategoryId];
  const servedAdultTotal = servedAdultTotalByRecCat[recipeCategoryId];
  const leftover = leftoverTotalByRecCat[recipeCategoryId];
  const discard = discardTotalByRecCat[recipeCategoryId];
  const servedReimbTotal = servedReimbTotalByRecCat[recipeCategoryId];
  const servedPreKTotal = servedPreKTotalByRecCat[recipeCategoryId];

  return (
    <Fragment>
      <div className="grid-item blue">{servedTotal}</div>
      {!collapsed && (
        <Fragment>
          <div className="grid-item blue">{servedPreKTotal}</div>
          <div className="grid-item blue">{servedAlacarteTotal}</div>
          <div className="grid-item blue">{servedAdultTotal}</div>
          <div className="grid-item blue">{leftover}</div>
          <div className="grid-item blue">{discard}</div>
          <div className="grid-item blue">{servedReimbTotal}</div>
          <div />
        </Fragment>
      )}
    </Fragment>
  );
}

const MemoizedServedSectionHeaderRow = React.memo(ServedSectionHeaderRow);

export { MemoizedServedSectionHeaderRow as ServedSectionHeaderRow };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/ServedSectionHeaderRow.js